import {Component} from '@angular/core'

@Component({
    selector:'app-recadastramento',
    templateUrl:'./recadastramento.component.html',
    styleUrls:['./recadastramento.component.scss']
})

export class recadastramentoComponent {}